var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.content)?_c('el-timeline-item',{attrs:{"icon":_vm.icon,"type":_vm.type,"color":_vm.color,"size":"large","timestamp":_vm.formatDate(_vm.activity.createdOn)}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.formattedActivityText)}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }